import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldFilterPipe } from './field-filter.pipe';
import { MomentPipe } from './moment.pipe';
import { NumberPipe } from './number.pipe';
import { CurrencyFormatPipe } from './currency-format.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FieldFilterPipe, MomentPipe, NumberPipe, CurrencyFormatPipe],
  exports: [FieldFilterPipe, MomentPipe, NumberPipe, CurrencyFormatPipe]
})
export class PipesModule { }
